module.exports = __webpack_public_path__ + "img/statusQuery.9c3a1d7a.png";